//slider init
supportedManufacturersSlider();

let carInfo = {
  "brand": null,
  "model": null
};

let makeNavigationSupportedManufactures = document.querySelector(".make-navigation-supported-manufactures");
let selectProductClassSpecial = document.querySelector(".select-product-class-special");

document.addEventListener("DOMContentLoaded", function () {
  initAnimations();
  initManufacturerHandles();
  initResetButtons();
  initClickableDiv();
});

function initAnimations() {
  const swiperSlides = document.querySelectorAll(".manufacturer-handle.animation-slide");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.animation = `fadeIn 0.5s ease-in-out ${entry.target.dataset.delay}s forwards`;
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  swiperSlides.forEach((slide, index) => {
    const isDesktop = window.innerWidth >= 1200; 
    const delayMultiplier = isDesktop ? 0.2 : 0;

    slide.style.opacity = "0";
    slide.style.animationDelay = `${index * delayMultiplier}s`;
    slide.dataset.delay = index * delayMultiplier;
    observer.observe(slide);
  });
}

function initManufacturerHandles() {
  document.querySelectorAll(".manufacturer-handle").forEach((handle) => {
    handle.addEventListener("click", () => {
      const button = handle.querySelector(".select-model");
      if (!button) return;

      const collections = JSON.parse(button.getAttribute("data-collections"));
      const selectedTitle = handle.querySelector(".model-title").textContent;

      //slider reload
      supportedManufacturersSlider();

      carInfo.brand = selectedTitle;

      updateSelectionTitle(".selection-model-title", selectedTitle);
      toggleSectionVisibility(".select-make", false);
      toggleSectionVisibility(".select-models", true);

      populateSwiperWrapper(collections);

      makeNavigationSupportedManufactures.style.display = "none";
      selectProductClassSpecial.style.display = "none";
    });
  });
}

function populateSwiperWrapper(collections) {
  const swiperWrapper = document.getElementById("select-models-wrapper");
  swiperWrapper.innerHTML = "";

  const fragment = document.createDocumentFragment();
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.animation = "fadeIn 0.5s ease-in-out forwards";
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  collections.forEach((collection) => {
    const newSlide = document.createElement("div");
    newSlide.className =
      "manufacturer-handle swiper-slide hover-color animation-slide newSlide";
    newSlide.style.opacity = "0";

    newSlide.innerHTML = `
      <p class="model-title">${collection.title}</p>
      ${
        collection.image
          ? `<img src="${collection.image}" alt="${collection.title}" />`
          : "<p>No image available</p>"
      }
      <p class="select-year" data-handle="${collection.url}">Select Year</p>
    `;

    newSlide.addEventListener("click", (event) => {
        handleSelectYear(newSlide);
    });

    fragment.appendChild(newSlide);
    observer.observe(newSlide);
  });

  swiperWrapper.appendChild(fragment);
}

function handleSelectYear(selectYearElement) {
  toggleSectionVisibility(".select-product", true);
  toggleSectionVisibility(".select-models", false);
  document.getElementById("product-list-icon").style.display = "flex";

  const selectedCollectionHandle = selectYearElement
    .querySelector(".select-year")
    .getAttribute("data-handle");
  const selectedCollectionTitle =
    selectYearElement.querySelector(".model-title").textContent;

    
  carInfo.model = selectedCollectionTitle;

  const isSmallScreen = window.innerWidth < 768.99;
  if(isSmallScreen) {
    updateSelectionTitle(".selection-collection-title", `<span class="product-reset-selection" style="text-decoration: underline; background: #fc3; border: none; color: black;">${carInfo.brand}</span>` + " <span style='color: white; display: flex; align-items: center;'>></span> " + `<span style="background: #fc3;
    border: none;
    color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: .5rem;
    border-radius: 1rem;">${carInfo.model}</span>`);
  } else {
    updateSelectionTitle(".selection-collection-title", `<span class="product-reset-selection" style="text-decoration: underline; background: none; border: none; padding: 0;">${carInfo.brand}</span>` + " <span style='color: white; display: flex; align-items: center;'>></span> " + carInfo.model);
  }
  
  initResetButtons();
  

   fetch(`${selectedCollectionHandle}/products.json`)
    .then((response) => response.json())
    .then((data) => {
      console.log("data.products --->", data.products); 
      //check engines here
      if(data.products.length) { 
        // console.log("engineleri var");
        populateProductSection(data.products);
      } else {
        // console.log("enginleri yok");
        populateProductSection();
      }
    })
    .catch((error) => console.error("Error fetching products:", error));
}

function splitTitle(title, searchStr = " - ") {
  let count = 0;
  let indices = [];
  let startIndex = 0;

  while (title.indexOf(searchStr, startIndex) !== -1) {
    indices.push(title.indexOf(searchStr, startIndex));
    count++;
    startIndex = title.indexOf(searchStr, startIndex) + searchStr.length;
  }

  if (count % 2 === 1 && count >= 3) {
    let splitIndex = indices[2];
    return [
      title.slice(0, splitIndex),
      title.slice(splitIndex + searchStr.length),
    ];
  } else if (count >= 2) {
    let splitIndex = indices[1];
    return [
      title.slice(0, splitIndex),
      title.slice(splitIndex + searchStr.length),
    ];
  } else {
    return [title];
  }
}

function populateProductSection(products) {
  if(products) {
    const productSectionContainer = document.getElementById(
    "product-section-container"
    );
    productSectionContainer.innerHTML = "";
  
    const fragment = document.createDocumentFragment();
  
    products.forEach((product) => {
      const productCard = document.createElement("div");
      productCard.className = "product-card";
      const pTitleArr = splitTitle(product.title);
  
      productCard.innerHTML = `
        <p class="product-title">${pTitleArr.map((each) => `${each}<br>`).join("")}</p>
        <div class="product-btn-wraper">
          <div class="product-logo">
            <img src="${product.images[0]?.src || ""}" alt="${product.title}">
          </div>
          <a href="/products/${
            product.handle
          }" class="buy-now-btn">Go to Product</a>
        </div>
      `;
  
      fragment.appendChild(productCard);
    });
  
    productSectionContainer.appendChild(fragment);
  } else {
    const productSectionContainer = document.getElementById(
    "product-section-container"
    );
    productSectionContainer.innerHTML = "NOT FOUND !";
  }
  
}

function updateSelectionTitle(selector, title) {
  const sectionTitle = document.querySelector(selector);
  if (sectionTitle) {
    sectionTitle.innerHTML = `Selection: <span class="yellow-color fs-x-large">${title}</span>`;
  }
}

function toggleSectionVisibility(selector, isVisible) {
  const section = document.querySelector(selector);
  if (section) {
    section.style.display = isVisible ? "block" : "none";
  }
}

function initResetButtons() {
  document
    .querySelectorAll(".reset-selection, .product-reset-selection")
    .forEach((button) => {
      button.addEventListener("click", () => {

        if (button.classList.contains("reset-selection")) {
          resetMakeSelection();
          
          //slider reload
          supportedManufacturersSlider();
        } else {
          resetProductSelection();
        }
      });
    });
}


function clickAllDDRESET() {
  let resetAll = document.querySelectorAll(".ResetAllbtn");
  if(resetAll) { 
    
    resetAll.forEach(item => {
      item.addEventListener("click" , () => {
        console.log("click edildi -->");
        let firstOne = document.querySelector(".product-reset-selection");
        let secondOne = document.querySelector(".reset-selection");
      
        if(firstOne && secondOne) {
          firstOne.click();
          secondOne.click();
        }
      })
    })
  }
}


function resetMakeSelection() {
  makeNavigationSupportedManufactures.style.display = "flex";
  selectProductClassSpecial.style.display = "flex";
  
  toggleSectionVisibility(".select-make", true);
  toggleSectionVisibility(".select-models", false);
  document.getElementById("select-models-wrapper").innerHTML = "";
}

function resetProductSelection() {
  toggleSectionVisibility(".select-models", true);
  toggleSectionVisibility(".select-product", false);
}

function initClickableDiv() {
  const clickableDiv = document.getElementById("clickableDiv");
  if (clickableDiv) {
    clickableDiv.addEventListener("click", () => {
      window.location.href = "/pages/other-makes";
    });
  }
}




function supportedManufacturersSlider() {
  // SUPPORTED MANUFACTURERS START
  const manufacturerSliders = document.querySelectorAll(
    ".hp-supported-manufacturers"
  );

  manufacturerSliders.forEach((container, i) => {
    container.style.display = "block !important";

    const next = container.querySelector(".slider-navigation .next");
    const prev = container.querySelector(".slider-navigation .prev");
    let finalNext = `.slider-navigation .next-${i}`;
    let finalPrev = `.slider-navigation .prev-${i}`;
    
     let eachManifacturersSlider = new Swiper(container.querySelector(".swiper"), {
      navigation: {
        // prevEl: prev,
        // nextEl: next,
        
        prevEl: finalPrev,
        nextEl: finalNext,
      },
      slidesPerView: 1.75,
      spaceBetween: 12,
      breakpoints: {
        560: { slidesPerView: 2.25 },
        768: { slidesPerView: 2.75 },
        960: { slidesPerView: 3.5 },
        1200: { slidesPerView: 5 },
      },
    });

  });

  // SUPPORTED MANUFACTURERS END
}

